import React from 'react'

export default function SettingsPage() {
  return (
    <div className='text-center'>
      <p>Cette page est en cours de construction</p>
    </div>
  )
}
